module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.basket.booking_items.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('div', {
    staticClass: "full-width border-bottom dark-blue",
    class: {
      'dark-red': _vm.basket.booking_state_id == 5
    }
  }, [_c('div', {
    staticClass: "booking-reference"
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.$parent.isThankyou && _vm.basket.booking_state_id != 5) ? _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$parent.locale.confirmation.text_thank_you))]) : (_vm.$parent.isThankyou && _vm.basket.booking_state_id == 5) ? _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$parent.locale.confirmation.text_thank_you_cancelled))]) : _vm._e(), _vm._v(" "), (_vm.$parent.isThankyou && _vm.basket.booking_state_id == 5) ? _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.$parent.locale.confirmation.text_booking_cancelled))]) : (_vm.$parent.isThankyou && _vm.basket.original_booking_item != null) ? _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.$parent.locale.confirmation.text_booking_edited))]) : (_vm.$parent.isThankyou) ? _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.$parent.locale.confirmation.text_booking_successful))]) : (_vm.basket.booking_state_description) ? _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.$parent.locale.text_booking_state_description_prefix) + " " + _vm._s(_vm.basket.booking_state_description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "booking-title"
  }, [(_vm.basket.booking_state_id == 5) ? _c('span', [_vm._v("cancelled")]) : _vm._e(), _vm._v(" booking reference\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "reference-number"
  }, [_vm._v("\n                            " + _vm._s(_vm.booking_id) + "\n                        ")])])])]), _vm._v(" "), (_vm.$parent.isThankyou && _vm.basket.booking_state_id != 5) ? _c('div', {
    staticClass: "full-width light-blue share-container"
  }, [_c('div', {
    staticClass: "share-box"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n                            " + _vm._s(_vm.$parent.locale.confirmation.text_social_header) + "\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("\n                            " + _vm._s(_vm.$parent.locale.confirmation.text_social_description) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "fa fa-facebook",
    attrs: {
      "id": "shareToFacebook"
    },
    on: {
      "click": _vm.share
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fa fa-twitter",
    attrs: {
      "id": "shareToTwitter"
    },
    on: {
      "click": _vm.tweet
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.$parent.isThankyou) ? _c('div', {
    staticClass: "full-width dark-blue share-container"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4"
  }, [_c('router-link', {
    staticClass: "cta-button blue",
    attrs: {
      "to": {
        name: 'account.overview'
      }
    }
  }, [_vm._v("Go to my account")])], 1)]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-889fd4da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Basket/Payment/PaymentConfirmation.vue
// module id = 186
// module chunks = 0